import React, { useState } from "react";
import { Grid, Modal } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import KendoButton from "assets/theme/components/button/kendo";
import { modalContainerStyle } from "pages/components/common/Styles";

const ConfirmationModal = ({
  open,
  onClose,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed?",
  confirmButtonText = "Confirm",
  confirmButtonColor = "info",
}) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    if (onConfirm) {
      await onConfirm();
    }
    setLoading(false);
    onClose();
  };

  return (
    <SoftBox>
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="confirmation-modal"
        aria-describedby="confirmation-modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <SoftBox sx={modalContainerStyle}>
          <SoftTypography variant="h4" component="h2" gutterBottom mb={2}>
            {title}
          </SoftTypography>
          <SoftTypography
            variant="h6"
            fontWeight="regular"
            id="confirmation-modal-description"
            gutterBottom
          >
            {message}
          </SoftTypography>
          <SoftBox>
            <Grid container justifyContent="flex-end" mt={3} spacing={1}>
              <Grid item xs={6} lg={4}>
                <SoftButton onClick={onClose} color="dark" fullWidth>
                  Cancel
                </SoftButton>
              </Grid>
              <Grid item xs={6} lg={4}>
                <KendoButton
                  type="button"
                  label={confirmButtonText}
                  onClick={handleConfirm}
                  loading={loading}
                  color={confirmButtonColor}
                  fullWidth
                />
              </Grid>
            </Grid>
          </SoftBox>
        </SoftBox>
      </Modal>
    </SoftBox>
  );
};

export default ConfirmationModal;
